var paginationData = {
  name: 'pagination',
  data: [{
    tight: false,
    // 新增，是否为紧凑型的
    itemWidth: 24,
    itemHeight: 24,
    itemRadius: 12,
    itemMargin: '',
    itemFontSize: 12,
    border: 'none',
    itemFontColor: '#666666',
    bgColor: 'inherit',
    hoverBorder: 'none',
    hoverBg: 'rgba(121, 121, 122, 0.1)',
    hoverFontColor: '#4588F4',
    activeBg: '#e4efff',
    activeBorderColor: '',
    activeFontColor: '#4f7de7',
    nextBorderRadius: '',
    prevBorderRadius: ''
  }]
};
export default paginationData;